import Star from "../../assets/images/svg/icon-start.svg";
import StarFilled from "../../assets/images/svg/icon-start-filled.svg";

interface ReviewsProp {
  score?: number;
  count?: number;
}

const Reviews: React.FC<ReviewsProp> = ({ score, count }) => {
  const reviewArr = Array.from(Array(5).keys());

  if (score === undefined || score <= 0) {
    return <></>;
  }

  return (
    <div className="reviews">
      <div className="reviews__stars">
        {score &&
          reviewArr.map((_, index) =>
            index + 1 <= score ? (
              <StarFilled key={index} />
            ) : (
              <Star key={index} />
            )
          )}
      </div>
      <span className="reviews__count">{count} Reviews</span>
    </div>
  );
};

export default Reviews;
